// Simple event emitter for avatar updates
class AvatarEventEmitter extends EventTarget {
  emitAvatarUpdate(avatarUrl: string) {
    this.dispatchEvent(new CustomEvent('avatar-updated', { 
      detail: { avatarUrl } 
    }));
  }
}

export const avatarEvents = new AvatarEventEmitter();